<template>
    <div class="big-log" v-show="$store.state.d2">
        
         <div class="content">
                <div class="pbg">
                    <div class="pmiddle"><img src="./images/LOGO.png" alt=""></div>
                </div>
                <div class="poster"><img src="./images/poster.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                <div class="logins">
                    <div class="login">
                        <div class="title">账号密码登录</div>
                        <div class="login-click">
                            <div class="agent" :class="{on:index==cur}" @click="changeOne(index)" v-for="(list,index) in lists" :key="index">{{list}}</div> 
                        </div>
                        <div class="input-bar">
                            <div class="account-bar">
                                <span class="account" v-show="account1">登录账号</span>
                                <input type="text" class="search-input" v-on:click="addAccount()" v-on:keyup="writeAccount()" @blur="showAccount()" v-model="input1">
                                <span class="noexist" v-show="noexist">账号不存在！</span>
                                <span class="delete" v-show="deletes" @click="hide()"><img src="./images/clear.png" alt=""></span>
                            </div>
                            <div class="password-bar">
                                <span class="account" v-show="account2">登录密码</span>
                                <input type="passWord" class="search-input" v-on:click="addPassword()" v-on:keyup='writePassword()' @blur='showPassword()' v-model="input2">
                                <span class="delete" v-show="deletes1" @click="hide1()"><img src="./images/clear.png" alt=""></span>
                            </div>
                        </div>
                        <div class="reads">
                            <div class="read">
                                <div class="check" ><img v-show="checkimg" src="./images/check.png" alt=""></div>
                                <span class="read-word">我已同意并已阅读<router-link tag="a" target="_blank" to="/agree">《维码器用户协议》</router-link></span>
                            </div>
                            <div class="forgot" v-show="!this.cur"><a href="http://www.weimaqi.net/admin_mchm_new/forgetpass.html">忘记密码</a></div>
                        </div>
                        <div class="enter" ref="bla" @click="enter()">登录</div>
                        <div class="change">切换<span class="phone" @click="change()">手机验证登录</span></div>
                    </div>

                    <!-- 手机验证码登录 -->
                    <div class="phone-verifi" :class="{ push : seen }" style="display: none;">
                        <div class="title">手机验证登录</div>
                        <div class="login-click">
                            <div class="agent" :class="{on:index==cur}" @click="changeOne(index)" v-for="(list,index) in lists" :key="index">{{list}}</div>          
                        </div>
                        <div class="input-bar">
                            <div class="account-bar">
                                <span class="account" v-show="phoneNum1">手机号</span>
                                <input type="text" class="search-input" v-on:click="addNum()" @blur='showPhonenum()' v-model="input3" maxlength="11" @keyup="eleven()">
                                <span class="get"  @click="getCode2()" v-show="getCode3" v-text="d4" :style="d5"></span>
                                <span class="sixty" ref="sixty1" v-show="sixty3" ></span>
                            </div>
                            <div class="password-bar">
                                <span class="account" v-show="authcode">验证码</span>
                                <input type="text" class="search-input" v-on:keyup="addCode()" @blur='showAuthcode()' v-on:click='addAuthcode()' v-model="input4">
                                <span class="delete" v-show="deletes2" @click="hide2()"><img src="./images/clear.png" alt=""></span>
                            </div>
                        </div>
                        <div class="reads">
                            <div class="read">
                                <div class="check"><img v-show="checkimg1" src="./images/check.png" alt=""></div>
                                <span class="read-word">我已同意并已阅读<router-link tag="a" target="_blank" to="/agree" v-on:click="showOne2()">《维码器用户协议》</router-link></span>
                            </div>
                        </div>
                        <div class="enter" ref="bla1">登录</div>
                        <div class="change">切换<span class="phone" @click="change()">账号密码登录</span></div>
                    </div>

                    <!--弹框-->
                    <div class="pw_pc" v-show="tankuang">
                    	<div class="pw_cha" @click="gourl1"></div>
                    	<div class="pw_top">
                    		<p class="zhubiaoti">紧急通知</p>
                    		<p class="fubiaoti">v2.0</p>
                    	</div>
                    	<div class="pw_content">
                    		<p class="pw_content_p">{{info}}</p>
                    		<div class="pw_btnbox">
                    			<button class="pw_btn" @click="gourl2">确定</button>
                    		</div>
                    	</div>
                    </div>
                    <div class="pwwhitemengban" v-show="tankuang"></div>

                </div>      
            </div> 
            <!--蒙版-->
        <div class="logs" @click.stop="hideLog()" ></div>

    </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import Navbar from '../Navbar'

export default {
  name:'log',
  components:{Navbar},
  data(){
      return{
          reg : /^1[0-9]{10}$/,
           
        // flag : this.reg.test(phoneNum),
         info:'',
          url1:'',
          url2:'',
          tankuang:false,
          seen:false,
          noexist:false,
          deletes:false,
          deletes1:false,
          deletes2:false,
          account1:true,
          account2:true,
          checkimg:true,
          checkimg1:true,
          authcode:true,
          phoneNum1:true,
          sixty3:false,
          getCode3:true,
          cur:0,
          lists:['商家登录','代理登录'],
          input1:'',
          input2:'',
          input3 : '',
          input4:'',
          d4: '获取验证码',
        // closeAgree:false,
        d5: {
            background:'',
            color:''
        },
        d6: true,
        showbg:true,
        isLog:true,
        status:0,
      }
  },
  methods:{
      change:function(){
          this.seen = !this.seen;
          this.account1 = true;
          this.account2 = true;
          this.authcode = true;
          this.phoneNum1 = true;
          this.input1 = '';
          this.input2 = '';
          this.input3 = '';
          this.input4 = '';
          this.deletes = false;
          this.deletes1 = false;
          this.deletes2 = false;
        //   this.checkimg = false;
        //   this.checkimg1 = false;
          this.$refs.bla.style.background = '#eaeaea';
          this.$refs.bla1.style.background = '#eaeaea';
          this.d5.background = '#f3f3f3';
      },
      changeOne(index){
          this.cur = index;
          this.account1 = true;
          this.account2 = true;
          this.authcode = true;
          this.phoneNum1 = true;
          this.input1 = '';
          this.input2 = '';
          this.input3 = '';
          this.input4 = '';
          this.deletes = false;
          this.deletes1 = false;
          this.deletes2 = false;
        //   this.checkimg = false;
        //   this.checkimg1 = false;
          this.$refs.bla.style.background = '#eaeaea';
          this.$refs.bla1.style.background = '#eaeaea';
           this.d5.background = '#f3f3f3';
      },
    //  键盘keyup
      writeAccount:function(){
          this.deletes = true;
          if(this.input1 !== '' && this.input2 !== ''){
              this.$refs.bla.style.background = '#198bfe';
          }else{
              this.$refs.bla.style.background = '#eaeaea';
          }
      },
      writePassword:function(){
          this.deletes1 = true;
          //this.input2 = this.input2.replace(/./g,'*');  //无法显示他本来的值，你需要在另外的地方保存他的真实密码.
          if(this.input1 !== '' && this.input2 !== ''){
              this.$refs.bla.style.background = '#198bfe';
          }else{
              this.$refs.bla.style.background = '#eaeaea';
          }
      },
      addAccount:function(){
          this.account1 = false;
      },
      addPassword:function(){
           this.account2 = false;
      },
    //   点击删除账号
       hide:function(){
          this.input1 = '',
          this.deletes = !this.deletes;
          this.account1 = true;
          if(this.input1 !== '' && this.input2 !== ''){
              this.$refs.bla.style.background = '#198bfe';
          }else{
              this.$refs.bla.style.background = '#eaeaea';
          }
      },
    //   点击删除密码
      hide1:function(){
          this.input2 = '',
          this.deletes1 = !this.deletes1;
          this.account2 = true;
          if(this.input1 !== '' && this.input2 !== ''){
              this.$refs.bla.style.background = '#198bfe';
          }else{
              this.$refs.bla.style.background = '#eaeaea';
          }
      },
    //   点击手机号码输入框的时候手机号码几个字隐藏
    addNum:function(){
        this.phoneNum1 = false;
        
    },
    //  验证码 键盘keyup
      addCode:function(){  
              this.deletes2 = true;
              if(this.input3 !== '' && this.input4 !== ''){
                    this.$refs.bla1.style.background = '#198bfe';
                }else{
                    this.$refs.bla1.style.background = '#eaeaea';
                }
      },
    //   点击input框的时候验证码几个字隐藏
     addAuthcode:function(){
         this.authcode = false;
    },
    //   点击手机验证的delete
      hide2:function(){
          this.input4 = '';
          this.deletes2 = false;
          this.authcode = true;
      },
      showAccount:function(){
          this.account1 = true;
      },
      showPassword:function(){
          this.account2 = true;
      },
      showPhonenum:function(){
          this.phoneNum1 = true;
      },
      showAuthcode:function(){
          this.authcode = true;
      },
    //   closeOne:function(){
    //       this.closeAgree = false;
    //   },
    //   手机号码正则判断
    eleven(){
        if(this.reg.test(this.input3) == true){
            // this.d5 = 'background:#198bfe';
            this.d5.background = '#198bfe';
            this.d5.color = '#fff';
            this.d6 = true;
        }else{
            this.d5.background = '#f3f3f3';
            this.d5.color = '#333';
            this.d6 = false;
        };
        if(this.input3.length == 11 && this.input4 == '' && this.reg.test(this.input3) == true){
            this.d6 = true;
        }

    },
    //点击获取验证码
    getCode2(){
        let that = this;  
        if(that.input3.length !== 11 && that.input4 == ''){
            that.d6 = false;
        }
    //    if(this.input3.length == 11 && this.input4 == '' && this.reg.test(this.input3) == true){
    //         this.d6 = true;
    //     }
        if (that.d6){
            that.d6 = false;
            var sum = 60;
            var timer = setInterval(function(){
            that.d5.background = '#f3f3f3';
            that.d5.color = '#333';
            that.d4 = sum + 's';    
            sum--;
            if(sum <0 ) {
                clearInterval(timer);
               that.d4 = '获取验证码';
               that.d5.background = '#198bfe';
               that.d5.color = '#fff';
               that.d6 = true;
            }
        },1000)
        }else{
        }
    },
    hideLog(){
        this.$store.state.d2 = !this.$store.state.d2;
        document.documentElement.style.overflow = "scroll";
    },
    //登录
     gourl1(){
    	window.location.href=this.url1;
    },
    gourl2(){
    	window.location.href=this.url2;
    },
    //登录
    enter(){
		if(this.cur==0){
			//var str={am:'m',mversion:'new',s:1,muid:this.input1,mpwd:this.input2};
			//电脑登录
			var postData = qs.stringify({
				am:'m',
				mversion:'new',
				s:1,
				muid:this.input1,
				mpwd:this.input2
			});	
		}else if(this.cur==1){
			//代理登录
			//var str={am:'a',mversion:'new',s:1,auid:this.input1,apwd:this.input2}
			var postData = qs.stringify({
			    am:'a',
			    aversion:'new',
			    s:1,
			    auid:this.input1,
			    apwd:this.input2
			});
		}
		
		axios({
		    method: 'post',
		    url:'https://weimaqi.net/admin_mch/login.aspx',
		    data:postData,
		    withCredentials: true
		}).then((response)=>{
			var data=response.data;
		    if(data[0].result==0){
		  		alert(data[0].info)
			}else if(data[0].result==1){
			  	if(data[0].url!=undefined){
			  		location.href=data[0].url
			  	}else{
			  		this.tankuang=!this.tankuang;
			  		this.info=data[0].info;
			  		this.url1=data[0].url1;
			  		this.url2=data[0].url2;
		  	}
			}
		}).catch((err)=>{
		})
	
},
  
//   mouted(){
//     var width = window.innerWidth || document.body.innerWidth || document.body.scrollWidth;
//     if(width < 768){
//         this.$store.state.d2 = true;
//     }
//   }
	}
 }
</script>

<style scoped>
.pbg{
    display: none;
}
.input-bar{
    margin-top: -30px;
}
.big-log{
     width:100%;
     height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* margin-top: -80px; */
    z-index: 99;
    position: fixed;
    top:0px;
    left: 0px;
}
.logs{
    width:100%;
    height: 100%;
    /* background: url(./images/bg.jpg) no-repeat; 
     background-size: cover; */
    z-index:99;
    position: fixed;
    top:0px;
    left: 0px;
    background: black;
    opacity: .5;
}
.content{
    width:900px;
    height: 600px;
    display: flex;
    z-index: 100;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -300px;
    margin-left: -450px;
    /* transform: translate(-50%, -50%); */
}
.logins{
    width:500px;
    height: 600px;
    overflow: hidden;
}
.login,.phone-verifi{
    width:500px;
    height: 600px;
    background: #fff;
    border-radius: 0px 10px 10px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
}
.login .title,.phone-verifi .title{
    font-size: 34px;
	font-family: 微软雅黑;
	letter-spacing: 2px;
    color: #333333;
    font-weight: bold;
}
.login-click{
    width: 424px;
	height: 58px;
	background-color: #f0f0f0;
	border-radius: 10px;
    display: flex;
    align-items: center;
}
.login-click .agent.on{
    width: 210px;
	height: 54px;
	background-color: #ffffff;
	border-radius: 10px;
    text-align: center;
    line-height: 54px;
    cursor: pointer;
    font-size: 16px;
    font-family: 微软雅黑;
    color: #999999;
    margin-left: 2px;
}
.login-click .agent{
    width: 210px;
	height: 54px;
	background-color: #f0f0f0;
	border-radius: 10px;
    text-align: center;
    line-height: 54px;
    cursor: pointer;
    font-size: 16px;
    font-family: 微软雅黑;
    color: #333;
}
.account-bar,.password-bar{
    width: 408px;
	height: 74px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
}
.account-bar .search-input,.password-bar .search-input{
    flex: 1;
    border: 0px;
    outline:none;
    margin-left: 10px;
    font-size: 14px;
    height: 65px;
    line-height: 65px;
}
.search-input::-ms-clear,.search-input::-ms-reveal{display:none;}
/* 去除input记住账号和密码默认出现黄色背景 */
.search-input:-webkit-autofill,.search-input:-webkit-autofill:focus  {
    box-shadow: 0 0 0px 100px white inset !important; 
   -webkit-box-shadow: 0 0 0px 1000px white inset !important; 
}
.delete{
    cursor: pointer;
}
.account{
    font-size: 14px;
    color: #333;
    font-family: 微软雅黑;
}
.noexist{
    font-size: 14px;
    color: #ff6262;
    font-family: 微软雅黑;
}
.reads{
    width: 408px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -26px;
    height: 21px;
}
.read{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.read .check{
    width: 16px;
	height: 16px;
	border-radius: 2px;
	border: solid 1px #f0f0f0;
    /* background: url(./images/check.png) no-repeat;
    background-size: cover; */
    margin-right: 10px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
.read .read-word{
    font-size: 14px;
    font-family: 微软雅黑;
    color: #333;
}
.read .read-word a{
    color: #198bfe;
    cursor: pointer;
}
.reads .forgot a{
    font-size: 14px;
    color: #999999;
    font-family: 微软雅黑;
    cursor: pointer;
}
.enter{
    width: 408px;
	height: 56px;
    line-height: 56px;
	background: #eaeaea;
	border-radius: 6px;
    font-family: 微软雅黑;
    text-align: center;
    color: #fff;
    cursor: pointer;
    margin-top: -22px;
}
.change{
    font-size: 14px;
    font-family: 微软雅黑;
    color: #999;
    margin-bottom: 30px;
}
.change .phone{
    color: #333;
    cursor: pointer;
}
.phone-verifi .account-bar .get{
    width: 88px;
	height: 32px;
    line-height: 32px;
	background: #f3f3f3;
    /* background: #198bfe; */
	border-radius: 6px;
    font-size: 14px;
    font-family: 微软雅黑;
    /* color: #999; */
    color: #333;
    text-align:center;
    cursor: pointer;
    display: block;
}
.phone-verifi .account-bar .sixty{
     width: 88px;
	height: 32px;
    line-height: 32px;
	background: #198bfe;
    /* background: #198bfe; */
	border-radius: 6px;
    font-size: 14px;
    font-family: 微软雅黑;
    /* color: #999; */
    color: #fff;
    text-align:center;
    cursor: pointer;
}
.phone-verifi.push{
    transform: translateY(-100%);
    z-index:9;
}


@media screen and (max-height: 800px){
.content{
        transform: scale(0.78);
    }
}

.change{display: none;}
.pwwhitemengban{width: 100%;height: 100%;position: fixed;top:0;left: 0;background: #fff;opacity: 0.1;filter: alpha(opacity=10);z-index:10}
.pw_pc{z-index:12000; position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);width: 580px;box-shadow: 0 0 20px #d8d8d8;border-radius: 20px;position:fixed;padding-bottom: 20px;background: #fff}.pw_top{width: 100%;height: 175px;background: url(images/pwtop_bg.png) no-repeat;background-size: contain;}.zhubiaoti{text-align: center;font-size: 30px;color: #fff;padding-top: 38px}.fubiaoti{text-align: center;font-size: 14px;color: #fff;padding-top: 5px}.pw_content{padding:0 100px;background: #fff}.pw_content_p{text-align:center;font-size: 14px;color: #666;line-height: 30px}.pw_btn{width: 180px;height: 50px;border-radius: 50px;display: block;margin:0 auto;box-shadow: none;border:none;font-size: 18px;color: #fff;box-shadow: 0 0 10px #97cdff;background: #0084ff}.pw_btnbox{margin-top: 30px}.pw_cha{width: 12px;height: 12px;position: absolute;right: 20px;top: 15px;cursor: pointer;}.pw_cha::before{content:"";background: #fff;width: 2px;height: 14px;position: absolute;transform: rotate(45deg);left:8px;}.pw_cha::after{content:"";background: #fff;width: 2px;height: 14px;position: absolute;transform: rotate(-45deg);left: 8px}.warn .pw_top{background: url(/images/pw_warnbg.png) no-repeat;background-size: contain;}.warn .pw_btn{background: #ff3a50;box-shadow: 0 0 10px #ffb6bd}

/* 手机 */
@media screen and (max-width:768px){
    .logs,.content .poster,.login-click,.title{
        display: none;
    }
    .big-log{
        z-index: 0;
        justify-content: space-between;
    }
    .pbg{
    display: block;
    width: 100%;
    height: 68px;
    background: url(./images/pbg.png) no-repeat;
    background-size: 100%;
    background-position: center;
    margin-top: 48px;
        display: flex;
    justify-content: center;
    align-items: center;
    }
    .content{
    width:100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: fixed; 
     top: 0px; 
     left: 0px; 
     margin-top: 0px; 
     margin-left: 0px; 
    transform: scale(1); 
    }
    .logins{
        width: 100%;
        height: calc(100vh - 116px);
    }
    .pmiddle{
    width: 84px;
    height: 16px;
    }
    .pmiddle img{
        width: 100%;
    }
    .login,.phone-verifi{
        width: 100%;
        height: 100%;
        padding: 0px 20px;
        box-sizing: border-box;
        justify-content: flex-start;
    }
    .input-bar{
        width:100%;
        margin-top: 22px;
    }
    .account-bar,.password-bar{
        width: 100%;
        height: 55px;
        /*line-height: 55px;*/
            border: 1px solid #e3e3e3;
        padding: 0px 10px 0px 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .password-bar{
        margin-top:15px;
    }
    
    .account-bar .search-input, .password-bar .search-input{
        height: 50px;
        line-height: 50px;
    }
    .reads{
        width:100%;
        margin-top:17px;
    }
    .enter{
        width:100%;
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        margin-top: 32px;
    }
    .read .read-word,.read .read-word a,.reads .forgot a{
        font-size: 12px;
    }
    .change{
        margin-top:19px;
        margin-bottom: 0px;
    }
    .change,.change>.phone{
        font-size: 13px;
    }
    .phone-verifi .account-bar .get{
    font-size:12px;
    width: 80px;
    height: 28px;
    line-height: 28px;
    white-space: nowrap;
    }
    .read .check{
        width:15px;
        height: 15px;
        margin-right:5px;
    }
    .account{
    display: block;
    width: 56px;
    white-space: nowrap;
    }
    .noexist{
        display: block;
        width: 85px;
        white-space: nowrap;
    }

}
</style>




// WEBPACK FOOTER //
// src/components/login/log.vue